

































































































































































































































import { Filter } from '@/interfaces/filter.interface'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

interface Pagination {
    currentPage: number;
    total: number;
    nextPage: boolean|null;
    previousPage: boolean|null;
    limit: number;
}

@Component
export default class Messages extends Vue {
    @Prop({ required: true }) getDateFormat!: (date: string) => {};
    @Prop({ required: true }) refreshTrigger!: boolean
    @Prop({ required: false }) providerId!: number
    @Prop({ required: true }) carrierId!: number
    @Prop({ required: true }) formData!: { msisdn: string; provider: null|number }

    localLoading = false

    exportLoading = false

    colorList = [
        '#c62828',
        '#283593',
        '#00695c',
        '#e65100',
        '#4e342e',
        '#6a1b9a'
    ]

    dateFilter: string[][] = []

    lastPage: number|null = null

    tables: {[key: string]: {data: object[]; columns: {text: string; value: string}[]}} = {
        messages: {
            data: [],
            columns: [
                {
                    text: 'ID',
                    value: 'id'
                },
                {
                    text: 'Origin',
                    value: 'origin'
                },
                {
                    text: 'Type',
                    value: 'type'
                },
                {
                    text: 'Shortcode',
                    value: 'shortcode'
                },
                {
                    text: 'Content',
                    value: 'content'
                },
                {
                    text: 'Status',
                    value: 'STATUS'
                },
                {
                    text: 'Product',
                    value: 'product'
                },
                {
                    text: 'Created At',
                    value: 'created_at'
                },
                {
                    text: 'Process At',
                    value: 'process_at'
                },
                {
                    text: 'Processed At',
                    value: 'processed_at'
                }
            ]
        }
    }

    messages: { pagination: Pagination; filters: Filter[]; filterList: Filter[] } = {
        pagination: {
            currentPage: 1,
            total: 0,
            nextPage: null,
            previousPage: null,
            limit: 15
        },
        filters: [],
        filterList: [
            {
                text: 'Shortcode',
                type: 'select',
                value: 'shortcodeId',
                queryValue: '',
                values: []
            },
            {
                text: 'Product',
                type: 'select',
                value: 'productId',
                queryValue: '',
                values: []
            },
            {
                text: 'Content',
                type: 'text',
                value: 'content',
                queryValue: ''
            },
            {
                text: 'Created At',
                type: 'date',
                value: 'createdAt',
                queryValue: ''
            },
            {
                text: 'Process At',
                type: 'date',
                value: 'processAt',
                queryValue: ''
            },
            {
                text: 'Processed At',
                type: 'date',
                value: 'processedAt',
                queryValue: ''
            }
        ]
    }

    @Watch('refreshTrigger')
    async refreshHandler () {
        this.localLoading = true
        await this.getShortcodes()
        await this.getProducts()
        await this.getMessages()
        this.localLoading = false
    }

    // @Watch('messages.filters')
    // onFiltersChange () {
    //     if (this.messages.filters.length === 0) this.filterHandler()
    // }

    onPaginationChange (params: { page: number}) {
        if (params.page !== this.lastPage) this.getMessages()
    }

    get unlockedFilters () {
        return this.messages.filterList.filter((f: Filter) => !f.locked)
    }

    get lockedFilters () {
        return this.messages.filterList.filter((f: Filter) => f.locked)
    }

    async mounted () {
        await this.getShortcodes()
        await this.getProducts()
    }

    getMessages () {
        this.lastPage = this.messages.pagination.currentPage
        return new Promise(resolve => {
            this.localLoading = true

            let localProvider = JSON.parse(JSON.stringify(this.providerId))
            if (!Array.isArray(localProvider)) localProvider = localProvider ? [localProvider] : []

            this.messages.filters.forEach((filter, i) => {
                if (filter.type === 'date') {
                    filter.queryValue = this.dateFilter[i]
                }
            })

            this.$store.dispatch('getMonitorMessages', {
                filters: [
                    {
                        value: 'page',
                        queryValue: this.messages.pagination.currentPage
                    },
                    {
                        value: 'limit',
                        queryValue: this.messages.pagination.limit
                    },
                    {
                        value: 'carrierId',
                        queryValue: this.carrierId
                    },
                    {
                        value: 'providerId',
                        queryValue: localProvider
                    },
                    {
                        value: 'msisdn',
                        queryValue: this.formData.msisdn
                    },
                    ...this.messages.filters
                ]
            })
                .then(resp => {
                    if (resp?.status === 200) {
                        this.messages.pagination.total = parseInt(resp.data.total)

                        const messages = resp.data.results

                        this.tables.messages.data = messages

                        this.shuffleColors()

                        let actualColor: string|null = null
                        let lastColor: string|null = null
                        let lastId: number|null = null
                        let colorIndex = 0

                        messages.forEach((m: { backgroundColor: string; incomingId: number }) => { // Set random colors
                            if (m.incomingId === lastId) {
                                if (lastColor) m.backgroundColor = lastColor
                            } else {
                                while (colorIndex > this.colorList.length - 1) {
                                    colorIndex -= this.colorList.length
                                }

                                actualColor = this.colorList[colorIndex]

                                lastColor = actualColor
                                lastId = m.incomingId
                                m.backgroundColor = actualColor
                                colorIndex++
                            }

                            if (!m.incomingId) m.backgroundColor = 'rgb(75 75 75)'
                        })

                        this.localLoading = false

                        this.$emit('localLoadingEnd')
                        resolve()
                    }
                })
        })
    }

    getShortcodes () {
        return new Promise(resolve => {
            this.$store.dispatch('getMonitorShortcodesFilter', { carrierId: this.carrierId, providerId: this.providerId })
                .then(resp => {
                    if (resp?.status === 200) {
                        resp.data.forEach((shortcode: {shortcodeId: number; shortcode: string}) => {
                            if (this.messages?.filterList[0]?.values) {
                                this.messages.filterList[0].values.push({
                                    text: shortcode.shortcode,
                                    value: shortcode.shortcodeId
                                })
                            }
                        })
                    }
                    resolve()
                })
        })
    }

    getProducts () {
        return new Promise(resolve => {
            this.$store.dispatch('getMonitorProductsFilter', { carrierId: this.carrierId, providerId: this.providerId })
                .then(resp => {
                    if (resp?.status === 200) {
                        resp.data.forEach((product: {productId: number; productName: string}) => {
                            if (this.messages?.filterList[1]?.values) {
                                this.messages.filterList[1].values.push({
                                    text: product.productName,
                                    value: product.productId
                                })
                            }
                        })
                    }
                    resolve()
                })
        })
    }

    selectColor (exeption?: string) {
        let color
        do {
            color = this.colorList[this.getRandomInt(this.colorList.length)]
        } while (color === exeption)
        return color
    }

    shuffleColors () {
        let currentIndex = this.colorList.length; let temporaryValue; let randomIndex

        // While there remain elements to shuffle...
        while (currentIndex !== 0) {
            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex)
            currentIndex -= 1

            // And swap it with the current element.
            temporaryValue = this.colorList[currentIndex]
            this.colorList[currentIndex] = this.colorList[randomIndex]
            this.colorList[randomIndex] = temporaryValue
        }
    }

    getRandomInt (max: number) {
        return Math.floor(Math.random() * Math.floor(max))
    }

    newLimitHandler (limit: number) {
        this.messages.pagination.limit = limit
        this.getMessages()
    }

    addFilter () {
        this.messages.filters.push(JSON.parse(JSON.stringify(this.messages.filterList[0])))
        this.dateFilter.push([])
    }

    removeFilter (filterIndex: number) {
        this.messages.filters = this.messages.filters.filter((filter, index) => index !== filterIndex)
        this.dateFilter = this.dateFilter.filter((filter, index) => index !== filterIndex)
        this.$forceUpdate()
    }

    updateFilter (index: number, newFilter: string) {
        const foundFilter = this.messages.filterList.find(filter => filter.value === newFilter)
        if (foundFilter) this.messages.filters[index] = JSON.parse(JSON.stringify(foundFilter))
        this.$forceUpdate()
    }

    async filterHandler () {
        this.messages.pagination = {
            currentPage: 1,
            total: 0,
            nextPage: null,
            previousPage: null,
            limit: 15
        }
        this.getMessages()
    }

    exportToCsv () {
        return new Promise(resolve => {
            this.exportLoading = true

            let localProvider = JSON.parse(JSON.stringify(this.providerId))
            if (!Array.isArray(localProvider)) localProvider = localProvider ? [localProvider] : []

            this.$store.dispatch('exportMessages', {
                filters: [
                    {
                        value: 'page',
                        queryValue: this.messages.pagination.currentPage
                    },
                    {
                        value: 'limit',
                        queryValue: this.messages.pagination.limit
                    },
                    {
                        value: 'carrierId',
                        queryValue: 1
                    },
                    {
                        value: 'providerId',
                        queryValue: localProvider
                    },
                    {
                        value: 'msisdn',
                        queryValue: this.formData.msisdn
                    },
                    ...this.messages.filters
                ]
            })
                .then(resp => {
                    this.exportLoading = false
                    if (resp.status === 200) {
                        const csvContent = 'data:text/csv;charset=utf-8,' + resp.data
                        const encodedUri = encodeURI(csvContent)
                        const link = document.createElement('a')

                        link.setAttribute('href', encodedUri)
                        link.setAttribute('download', `messages-${this.getDateFormat(new Date().toString())}.csv`)
                        document.body.appendChild(link)
                        link.click()
                        resolve()
                    }
                })
        })
    }
}

